import setCSSVar from "../utils/setCssVar";
import debounce from "../utils/debounce";
export default class StackedCards {
  constructor(elem) {
    this.elem = elem;
    this.cards = elem.querySelectorAll(".js-stacked-cards-card");
    this.topHeight = 0;
    this.cardScrollTopPositions = [];
    this.cardsGrid = elem.querySelector(".js-stacked-cards-grid");
    this.triggers = elem.querySelectorAll(".js-accgrid-trigger");
  }

  setHeadlineHeight() {
    this.cards.forEach((card, index) => {
      if (index > 0) {
        setCSSVar(card, "--card-top-pos", `${this.topHeight}px`);
      } else {
        setCSSVar(card, "--card-top-pos", "5px");
      }

      const headline = card.querySelector(".js-stacked-cards-headline");
      const headlineHeight = headline.offsetHeight;
      const cardTopPadding = parseInt(window.getComputedStyle(card).paddingTop, 10);
      const previousCards = Array.from(this.cards).slice(0, index);
      const previousCardHeight = previousCards.reduce((acc, card) => acc + card.offsetHeight, 0);
      this.topHeight += headlineHeight + cardTopPadding;

      this.cardScrollTopPositions.push(previousCardHeight - cardTopPadding * index);

      // on last card, add the spacer height
      if (index === this.cards.length - 1) {
        setCSSVar(this.elem, "--stacked-cards-spacer-height", `${this.topHeight}px`);
      }
    });
  }

  handleCardClick() {
    this.cards.forEach((card, index) => {
      card.addEventListener("click", (e) => {
        if (e.target.tagName === "A") return

        e.preventDefault();
        const cardTop = this.cardsGrid.getBoundingClientRect().top + window.scrollY + this.cardScrollTopPositions[index];

        window.scrollTo({
          top: cardTop,
          behavior: "smooth",
        });
      });
    });
  }

  handleTallestTrigger() {
    // reset the tallest trigger height
    setCSSVar(this.elem, "--stacked-cards-tallest-trigger", "0px");
    
    const tallestTrigger = Array.from(this.triggers).reduce((acc, trigger) => {
      return trigger.offsetHeight > acc.offsetHeight ? trigger : acc;
    });

    setCSSVar(this.elem, "--stacked-cards-tallest-trigger", `${tallestTrigger.offsetHeight}px`);
  }


  init() {
    this.setHeadlineHeight();
    this.handleTallestTrigger();
    window.addEventListener("resize", debounce(() => {
      this.topHeight = 0;
      this.setHeadlineHeight();
      this.handleTallestTrigger();
    }, 100));
    this.handleCardClick();
  }
}